import React, { useEffect, useState } from 'react';
import { facebookApi, productsApi } from '../services/api';

export default function FacebookPublish() {
  const [products, setProducts] = useState([]);
  const [posts, setPosts] = useState([]);
  const [selected, setSelected] = useState([]);
  const [form, setForm] = useState({ message: '', deadline: '' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    productsApi.list({ limit: 200 }).then(r => setProducts(r.data));
    facebookApi.posts().then(p => setPosts(p.slice(0, 10)));
  }, []);

  function toggleProduct(id) {
    setSelected(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id]);
  }

  async function publish() {
    if (!selected.length) return setMsg('Vyberte alespoň jeden produkt');
    setLoading(true);
    try {
      const result = await facebookApi.publish({ product_ids: selected, ...form });
      setMsg(`Příspěvek publikován! ID: ${result.post_id}`);
      setSelected([]);
      facebookApi.posts().then(p => setPosts(p.slice(0, 10)));
    } catch (err) {
      setMsg(`Chyba: ${err}`);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="page-header"><h1 className="page-title">📣 Facebook publikace</h1></div>

      {msg && <div className={`alert ${msg.startsWith('Chyba') ? 'alert-error' : 'alert-success'}`}>{msg}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: 16 }}>
        {/* Product selection */}
        <div className="card">
          <div className="card-title" style={{ marginBottom: 12 }}>Vyberte produkty pro příspěvek</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 10 }}>
            {products.filter(p => p.is_active).map(p => (
              <div
                key={p.id}
                onClick={() => toggleProduct(p.id)}
                style={{
                  border: `2px solid ${selected.includes(p.id) ? 'var(--blue)' : 'var(--border)'}`,
                  borderRadius: 8, overflow: 'hidden', cursor: 'pointer',
                  background: selected.includes(p.id) ? 'var(--blue-light)' : 'white',
                  transition: 'all 0.15s',
                }}>
                <div style={{ height: 100, background: '#f5f5f0', overflow: 'hidden' }}>
                  {p.image_url ? <img src={p.image_url} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', fontSize: 36 }}>📦</div>}
                </div>
                <div style={{ padding: '8px 10px' }}>
                  <div style={{ fontSize: 12, fontWeight: 600, lineHeight: 1.3 }}>{p.name}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--blue)', marginTop: 4 }}>{p.price_sell} Kč</div>
                  {selected.includes(p.id) && <div style={{ fontSize: 11, color: 'var(--blue)', marginTop: 2 }}>✓ Vybráno</div>}
                </div>
              </div>
            ))}
          </div>
          {selected.length > 0 && (
            <div style={{ marginTop: 12, padding: '10px', background: 'var(--blue-light)', borderRadius: 6, fontSize: 13, color: 'var(--blue)' }}>
              Vybráno: {selected.length} produktů
            </div>
          )}
        </div>

        {/* Publish form */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="card">
            <div className="card-title" style={{ marginBottom: 12 }}>Nastavení příspěvku</div>
            <div className="form-group">
              <label className="form-label">Uzávěrka objednávek</label>
              <input className="form-control" type="datetime-local" value={form.deadline} onChange={e => setForm(f => ({...f, deadline: e.target.value}))} />
            </div>
            <div className="form-group">
              <label className="form-label">Vlastní zpráva (nepovinné)</label>
              <textarea className="form-control" rows={5} placeholder="Pokud nevyplníte, systém automaticky vygeneruje text z produktů..." value={form.message} onChange={e => setForm(f => ({...f, message: e.target.value}))} />
            </div>
            <button className="btn btn-primary" style={{ width: '100%' }} onClick={publish} disabled={loading || !selected.length}>
              {loading ? '⏳ Publikuji...' : '📣 Publikovat na Facebook'}
            </button>
          </div>

          {/* Recent posts */}
          <div className="card">
            <div className="card-title" style={{ marginBottom: 12 }}>Poslední příspěvky</div>
            {posts.length === 0 && <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Žádné příspěvky</div>}
            {posts.map(p => (
              <div key={p.id} style={{ padding: '8px 0', borderBottom: '1px solid var(--border-light)', fontSize: 13 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span className={`badge ${p.status === 'published' ? 'badge-paid' : 'badge-waiting'}`}>{p.status}</span>
                  <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{p.published_at?.slice(0, 10)}</span>
                </div>
                <div style={{ marginTop: 4, fontSize: 12, color: 'var(--text-muted)', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                  {p.message}
                </div>
                {p.post_url && <a href={p.post_url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: 'var(--blue)', marginTop: 4, display: 'block' }}>Zobrazit na FB →</a>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
